module.exports = __webpack_public_path__ + "img/whathot_bg_mobile_lightblue.b705029c.png";